import { GAME_CATALOG } from '@/catalog/games';
import { useI18n } from '@/i18n';
import { GameCard } from '@/modules/landing/GameCard';

export function LandingPage() {
  const { t } = useI18n();

  return (
    <div className="space-y-6">
      <section className="text-center">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-dp-ink sm:text-4xl">
          {t('heroTitle')}
        </h1>
        <p className="mt-2 text-sm text-dp-muted sm:text-base">{t('heroSubtitle')}</p>
        <p className="mt-1 text-xs text-dp-muted/80">{t('tagline')}</p>
      </section>

      <section className="grid gap-3" aria-label={t('heroTitle')}>
        {GAME_CATALOG.map((game) => (
          <GameCard key={game.id} game={game} />
        ))}
      </section>
    </div>
  );
}
